import { Component, OnInit } from "@angular/core";
import { CardElement } from "../shared-card-grid/shared-card-grid.component";

interface EducationItem {
  institute: string;
  logo: string;
  degreeName: string;
  degreeTime: string;
  text: string;
}

@Component({
    selector: "app-education",
    templateUrl: "./education.component.html",
    styleUrls: ["./education.component.css"],
    standalone: false
})
export class EducationComponent {
  educationItems: EducationItem[] = [
    {
      institute: "UCL",
      logo: "assets/logos/ucl.png",
      degreeName: "MSc Data Science and Machine Learning",
      degreeTime: "September 2018 - August 2019",
      text: "Awarded with Distinction",
    },
    {
      institute: "Aristotle University of Thessaloniki",
      logo: "assets/logos/auth.png",
      degreeName: "BSc Informatics",
      degreeTime: "September 2012 - June 2017",
      text: "Awarded with Distinction (GPA: 9.59/10)",
    },
  ];

  constructor() {}

  getCards() {
    return this.educationItems.map(
      (x) =>
        <CardElement>{
          logo: x.logo,
          title: x.degreeName,
          subtitle: x.institute,
          mainText: x.text,
          time: x.degreeTime,
        }
    );
  }
}
